function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 421.141 421.141",
  style: {
    "enableBackground": "new 0 0 421.141 421.141"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFD7A3"
  },
  d: "M138.277,274.566c14.716-9.475,13.07-37.675,13.07-44.255h118.446c0,6.58-1.825,34.78,12.89,44.255 l-72.113,80.771L138.277,274.566z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FDC88E"
  },
  d: "M256.632,302.695l26.051-28.129c-14.716-9.474-12.89-37.675-12.89-44.255H151.347 C159.845,254.744,216.054,296.663,256.632,302.695z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M302.695,144.767c0,52.696-30.343,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 s41.246-72.384,92.124-72.384S302.695,92.071,302.695,144.767z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M121.521,156.283c-9.864-2.468-16.326,2.805-16.326,13.161c0,13.709,13.265,47.296,27.21,26.321 C146.351,174.79,121.521,156.283,121.521,156.283z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M297.944,156.283c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S297.944,156.283,297.944,156.283z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7E5449"
  },
  d: "M138.187,118.446c-2.742,7.887-6.58,52.643-6.58,52.643l-13.161-7.281l-3.701-48.234 L138.187,118.446z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7E5449"
  },
  d: "M282.954,118.446c2.742,7.887,6.58,52.643,6.58,52.643l13.161-7.281l3.701-48.234L282.954,118.446z "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#527992"
  },
  d: "M361.918,421.141c10.903,0,19.741-8.838,19.741-19.741v-50.303 c0-28.954-22.562-59.864-50.138-68.687l-41.168-13.173c-22.149,16.936-53.802,40.039-79.782,40.039s-57.633-23.103-79.782-40.039 L89.62,282.41c-27.576,8.823-50.138,39.733-50.138,68.687V401.4c0,10.903,8.838,19.741,19.741,19.741H361.918z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#545465"
  },
  d: "M223.731,329.016c0,3.619-2.961,6.58-6.58,6.58H203.99c-3.619,0-6.58-2.961-6.58-6.58v-13.161 c0-3.619,2.961-6.58,6.58-6.58h13.161c3.619,0,6.58,2.961,6.58,6.58V329.016z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#D0D7DC"
  },
  cx: 210.57,
  cy: 368.498,
  r: 6.58
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#475F7F"
  },
  d: "M210.57,309.275l-27.456,27.456c-2.859,2.859-7.596,2.487-9.975-0.783l-48.113-66.156 l15.326-15.326c2.475-2.475,6.454-2.579,9.055-0.238L210.57,309.275z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#475F7F"
  },
  d: "M210.57,309.275l27.456,27.456c2.859,2.859,7.596,2.487,9.975-0.783l48.113-66.156l-15.326-15.326 c-2.475-2.475-6.454-2.579-9.055-0.238L210.57,309.275z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#545465"
  },
  points: "219.611,331.895 210.57,335.596 201.53,331.895 197.41,421.141 210.57,421.141  223.731,421.141 \t\t"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M364.235,420.907c9.797-1.16,17.423-9.399,17.423-19.507v-50.303 c0-28.954-22.562-59.864-50.138-68.687l-35.879-11.481h0l-52.169,149.978H364.235z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M125.499,270.929L125.499,270.929L89.62,282.41c-27.576,8.823-50.138,39.733-50.138,68.687V401.4 c0,10.109,7.627,18.347,17.423,19.507h120.764L125.499,270.929z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M125.026,269.793l-27.989,33.837c-2.605,2.993-1.988,7.594,1.314,9.795l13.515,9.01l-15.633,15.633 c-2.347,2.347-2.579,6.073-0.541,8.693l42.496,74.379l39.482-0.234L125.026,269.793z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M296.114,269.793l27.989,33.837c2.605,2.993,1.988,7.594-1.314,9.795l-13.515,9.01l15.633,15.633 c2.347,2.347,2.579,6.073,0.541,8.693l-42.496,74.379l-39.482-0.234L296.114,269.793z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M309.275,118.446c-65.803,0-131.606,0-197.41,0c0-35.095,0-59.654,0-94.749 c62.01-31.596,135.399-31.596,197.41,0C309.275,58.792,309.275,83.351,309.275,118.446z"
}))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/2.bc3c38fd.svg";
export { SvgComponent as ReactComponent };